import { History } from 'history'
import rootReducer from '@modules/reducers'
import rootSaga from '@modules/sagas'
import createStore from './createStore'

const store = (history: History) =>  createStore(history, rootReducer, rootSaga)

export default store
